






















































import api from "@/api/index"; //ABP API接口
import { Vue, Component, Ref } from "vue-property-decorator";
import {
  FundDtoPagedResultDto,
} from "@/api/appService";
import PagedTableView from "@/components/PagedTableView/index.vue";
import AbSelect from "@/components/AbSelect/index.vue";
import AgileAuditTag from "@/components/AgileAuditTag/index.vue";

@Component({
  name: "FundNoCashDonationList",
  components: {
    PagedTableView,
    AbSelect,
    AgileAuditTag
  },
  filters: {
    formatStatus(type: string, statusList: any[]) {
      let result = "";
      statusList.forEach(item => {
        if (item.value == type) {
          result = item.text
          return
        }
      })
      return result
    }
  }
})
export default class FundNoCashDonationList extends Vue {
  typeList: any = [{
    text: '物品捐赠',
    value: 1
  }, {
    text: '场地/其他捐赠',
    value: 2
  }];
  queryForm = {
  };

  created() {
  }

  // 获取表数据
  fetchData(params: any) {
    return api.fundNonCashDonation.getAll(params);
  }

  // 新建
  handleCreate() {
    this.$router.push({
      name: "fundNonCashDonationCreate",
    });
  }

  // 查看详情
  jumpDetail(id: number) {
    this.$router.push({
      name: "fundNonCashDonationDetail",
      params: {
        id: id!.toString(),
      }
    });
  }
}
